<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_0#uecmoQc7wNObFpqUz6HQneA">L’histoire de Mobile Mardi Gras et le Carnaval Saisonnier</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01#uUIgYpazpUwmXbh36CVi5t8">Chapter 1 – The Crime</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02#uXzifiVUiQ9MnBUBEKh2yTG">Chapter 2 – The Victim</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_03#uYnZorHwFbNY3emceXLSifD" title="Link target outside of Sample">Chapter 3 – The Investigation: Finding leads</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_04#uIhdqmribHoRdJ88AyDJml6" title="Link target outside of Sample">Chapter 4 –A New Assignment</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_05#uXKt9rVGEbeUNuOMz6ifTR8" title="Link target outside of Sample">Chapter 5 - The Cold Case</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_06#umfS5lIeILmoz6QuTvOEGCH" title="Link target outside of Sample">Chapter 6 - The Sting (Getting his DNA)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_07#uIRJ8VvCj5OTdkm8NGAiK64" title="Link target outside of Sample">Chapter 7 – The Indictment</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_08#uBZD2FfXAJnjBcZHjD8fQQ5" title="Link target outside of Sample">Chapter 8 – The Arrest and Confession</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_09#uxoNU7uHtumsXE47pG7bQpG" title="Link target outside of Sample">Chapter 9 – The Search</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10#uqwVY3Ip6j5J9wx277tjCAA" title="Link target outside of Sample">Chapter 10 – The Confession</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11#uagc3QLoEQu5e7qXhLeTRI2" title="Link target outside of Sample">Chapter 11 – The Confession, Day Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12#uDs2hGgIeSOVKmsfEDH26pA" title="Link target outside of Sample">Chapter 12 – The Ohio Hearing</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13#uhRPIwQ9UcPYd32VEjmY9f5" title="Link target outside of Sample">Chapter 13 – The Legal Proceedings and Trial</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?aa3b6c74